<template>
	<el-container class="friend-page">

		<el-container class="friend-box">
			<div class="friend-header" v-show="userInfo.id">
				{{ userInfo.nickName }}
			</div>
			<div v-show="userInfo.id">
				<div class="friend-detail">
					<head-image :size="160" :name="userInfo.nickName" :url="userInfo.headImage" radius="10%"
						@click.native="showFullImage()"></head-image>
					<div>
						<div class="info-item">
							<el-descriptions title="好友信息" class="description" :column="1">
								<el-descriptions-item label="用户名">{{ userInfo.userName }}
								</el-descriptions-item>
								<el-descriptions-item label="昵称">{{ userInfo.nickName }}
								</el-descriptions-item>
								<el-descriptions-item label="性别">{{ userInfo.sex == 0 ? "男" : "女"
								}}</el-descriptions-item>
								<el-descriptions-item label="签名">{{ userInfo.signature }}</el-descriptions-item>
							</el-descriptions>
						</div>
						<div class="frient-btn-group">
							<el-button v-show="isFriend" icon="el-icon-position" type="primary"
								@click="onSendMessage(userInfo)">发消息</el-button>
							<el-button v-show="!isFriend" icon="el-icon-plus" type="primary"
								@click="onAddFriend(userInfo)">加为好友</el-button>
							<el-button v-show="isFriend" icon="el-icon-delete" type="danger"
								@click="onDelFriend(userInfo)">删除好友</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-container>
	</el-container>
</template>

<script>
import AddFriend from "../components/friend/AddFriend.vue";
import HeadImage from "../components/common/HeadImage.vue";
import { pinyin } from 'pinyin-pro';

export default {
	name: "friend",
	components: {
		AddFriend,
		HeadImage

	},
	props: {
		friendData: {
			type: Object,
			default: () => null
		}
	},
	data() {
		return {
			searchText: "",
			showAddFriend: false,
			userInfo: {}
		}
	},
	methods: {
		onShowAddFriend() {
			this.showAddFriend = true;
		},
		onCloseAddFriend() {
			this.showAddFriend = false;
		},
		onActiveItem(friend) {
			this.activeFriend = friend;
			this.loadUserInfo(friend.id);
		},
		onDelFriend(friend) {
			this.$confirm(`确认删除'${friend.nickName}',并清空聊天记录吗?`, '确认解除?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				if (res && res.status === "PENDING") {
					this.$message.info("已发送好友申请，等待对方验证");
					return;
				}
				this.$http({
					url: `/friend/delete/${friend.id}`,
					method: 'delete'
				}).then((res) => {
				if (res && res.status === "PENDING") {
					this.$message.info("已发送好友申请，等待对方验证");
					return;
				}
					this.$message.success("删除好友成功");
					this.$store.commit("removeFriend", friend.id);
					this.$store.commit("removePrivateChat", friend.id);
				})
			})
		},
		onAddFriend(user) {
			this.$http({
				url: "/friend/add",
				method: "post",
				params: {
					friendId: user.id
				}
			}).then((res) => {
				if (res && res.status === "PENDING") {
					this.$message.info("已发送好友申请，等待对方验证");
					return;
				}
				this.$message.success("添加成功，对方已成为您的好友");
				let friend = {
					id: user.id,
					nickName: user.nickName,
					headImage: user.headImage,
					online: user.online
				}
				this.$store.commit("addFriend", friend);
			})
		},
		async onSendMessage(user) {
			// 构造聊天数据
			let chatData = {
				type: 'PRIVATE',
				targetId: user.id,
				showName: user.nickName,
				headImage: user.headImageThumb || user.headImage,
			};
			
			// 打开聊天会话
			this.$store.commit("openChat", chatData);
			
			// 查找会话索引
			const chatIndex = this.$store.getters.findChatIdx(chatData);
			if (chatIndex !== undefined && chatIndex !== -1) {
				// 激活会话
				this.$store.commit("activeChat", chatIndex);
				
				// 在VSCode环境中，需要同步到统一会话服务并通知编辑器面板
				if (window.vscodeServices) {
					console.log('[EditorFriend] 在VSCode环境中，同步并激活编辑器面板会话');
					try {
						// 获取当前激活的会话
						const activeChat = this.$store.state.chatStore.chats[chatIndex];
						
						// 生成统一会话ID
						const unifiedSessionId = `vue-im-${user.id}`;
						
						// 获取统一会话服务
						const unifiedSessionService = window.vscodeServices.get('IUnifiedSessionService');
						if (unifiedSessionService) {
							// 检查会话是否已存在
							const sessionExists = unifiedSessionService.getAllSessions &&
								unifiedSessionService.getAllSessions().some(s => s.id === unifiedSessionId);
							
							if (!sessionExists && unifiedSessionService.syncVueSessionsFromWebView) {
								console.log("[EditorFriend] 会话不存在，进行增量同步...");
								// 同步单个会话到统一服务
								const sessionData = {
									id: user.id,
									sessionId: user.id,
									showName: user.nickName,
									type: 'vue-im',
									headImage: user.headImageThumb || user.headImage,
									lastSendTime: Date.now(),
									messages: activeChat?.messages || []
								};
								unifiedSessionService.syncVueSessionsFromWebView([sessionData]);
								// 等待同步完成
								await new Promise(resolve => setTimeout(resolve, 50));
							}
							
							// 激活会话
							if (unifiedSessionService.setActiveSession) {
								unifiedSessionService.setActiveSession(unifiedSessionId);
								console.log("[EditorFriend] ✅ 已调用统一会话激活:", unifiedSessionId);
							}
						}
						
						// 使用面板管理服务打开编辑器
						const panelManagerService = window.vscodeServices.get('panelManagerService');
						if (panelManagerService && panelManagerService.openChatEditor) {
							const chatUser = {
								id: user.id,
								nickName: user.nickName,
								name: user.nickName,
								headImage: user.headImageThumb || user.headImage,
								headImageThumb: user.headImageThumb || user.headImage,
								avatar: user.headImage,
							};
							panelManagerService.openChatEditor(chatUser);

							this.$store.commit("changeViewCode", 1);// 切换到聊天页面
							console.log("[EditorFriend] ✅ 聊天编辑器面板已打开:", user.nickName);
						} else {
							console.warn("[EditorFriend] ⚠️ PanelManagerService或openChatEditor方法不可用");
						}
					} catch (error) {
						console.error("[EditorFriend] ❌ 激活编辑器面板失败:", error);
					}
				}
			}
			
			// 检查是否在PluginChat环境中
			if (this.$parent && this.$parent.$options.name === 'PluginChat') {
				console.log('[EditorFriend] 在PluginChat环境中，触发startChat事件');
				// 触发父组件的startChat事件
				this.$emit('startChat', chatData);
				return;
			}

			// 原有的路由跳转逻辑（用于其他页面）
			if (!window.vscodeServices) {
				this.$router.push("/home/chat");
			}
		},
		showFullImage() {
			if (this.userInfo.headImage) {
				this.$store.commit('showFullImageBox', this.userInfo.headImage);
			}
		},
		updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				let friend = JSON.parse(JSON.stringify(this.activeFriend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				this.$store.commit("updateChatFromFriend", friend);
				this.$store.commit("updateFriend", friend);
			}
		},
		loadUserInfo(id) {
			// 获取好友用户信息
			this.$http({
				url: `/user/find/${id}`,
				method: 'GET'
			}).then((userInfo) => {
				this.userInfo = userInfo;
				this.updateFriendInfo();
			})
		},
		firstLetter(strText) {
			// 使用pinyin-pro库将中文转换为拼音
			let pinyinOptions = {
				toneType: 'none', // 无声调
				type: 'normal' // 普通拼音
			};
			let pyText = pinyin(strText, pinyinOptions);
			return pyText[0];
		},
		isEnglish(character) {
			return /^[A-Za-z]+$/.test(character);
		}
	},
	computed: {
		activeFriend() {
			return this.$store.state.friendStore.activeFriend;
		},
		friendStore() {
			return this.$store.state.friendStore;
		},
		isFriend() {
			return this.$store.getters.isFriend(this.userInfo.id);
		},
		friendMap() {
			// 按首字母分组
			let map = new Map();
			this.friendStore.friends.forEach((f) => {
				if (f.deleted || (this.searchText && !f.nickName.includes(this.searchText))) {
					return;
				}
				let letter = this.firstLetter(f.nickName).toUpperCase();
				// 非英文一律为#组
				if (!this.isEnglish(letter)) {
					letter = "#"
				}
				if (f.online) {
					letter = '在线'
				}
				if (map.has(letter)) {
					map.get(letter).push(f);
				} else {
					map.set(letter, [f]);
				}
			})
			// 排序
			let arrayObj = Array.from(map);
			arrayObj.sort((a, b) => {
				// #组在最后面
				if (a[0] == '#' || b[0] == '#') {
					return b[0].localeCompare(a[0])
				}
				return a[0].localeCompare(b[0])
			})
			map = new Map(arrayObj.map(i => [i[0], i[1]]));
			return map;
		},
		friendKeys() {
			return Array.from(this.friendMap.keys());
		},
		friendValues() {
			return Array.from(this.friendMap.values());
		}
	},
	watch: {
		activeFriend(newFriend, oldFriend) {
			this.onActiveItem(newFriend);
		},
		// 监听传入的好友数据
		friendData: {
			handler(newFriendData) {
				if (newFriendData && newFriendData.id) {
					console.log('[EditorFriend] 接收到好友数据:', newFriendData);
					// 设置活跃好友
					this.$store.commit("setActiveFriend", newFriendData);
					// 加载用户详细信息
					this.loadUserInfo(newFriendData.id);
				}
			},
			immediate: true
		}
	}
}
</script>

<style lang="scss">
.friend-page {
	background-color: #f1f1f1;
	height: 100%;
	.friend-list-box {
		display: flex;
		flex-direction: column;
		background: var(--im-background);

		.friend-list-header {
			height: 50px;
			display: flex;
			align-items: center;
			padding: 0 8px;

			.add-btn {
				padding: 5px !important;
				margin: 5px;
				font-size: 16px;
				border-radius: 50%;
			}
		}

		.friend-list-items {
			flex: 1;

			.index-title {
				text-align: left;
				font-size: var(--im-larger-size-larger);
				padding: 5px 15px;
				color: var(--im-text-color-light);
			}
		}
	}

	.friend-box {
		display: flex;
		flex-direction: column;

		.friend-header {
			height: 50px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 12px;
			font-size: var(--im-font-size-larger);
			border-bottom: var(--im-border);
			box-sizing: border-box;
		}

		.friend-detail {
			display: flex;
			padding: 50px 80px 20px 80px;
			text-align: center;

			.info-item {
				margin-left: 20px;
				background-color: #ffffff;
				border: 1px #ddd solid;
			}

			.description {
				padding: 20px 20px 0 20px;
			}
		}

		.frient-btn-group {
			text-align: left !important;
			padding: 20px;
		}
	}
}
</style>